import React, {useContext, useEffect, useState} from "react";
import {Route, Switch} from "react-router-dom";
import moment from "moment";
import PreviewBox from "./PreviewBox";
import ToolsBar from "../../../toolsBar/analyze/ToolsBar";
import Listing from "../../../table/Listing";
import ExportStats from "../analyze/ExportStats";
import usePrevious from "../../../../class/tool/usePrevious";
import FilterPopup from "../../../table/FilterPopup";
import DashboardController from "../../../../stories/_statistic/Dashboard/DashboardController";
import ListingContext from "../../../../context/ListingContext";
import StatisticContext from "../../../../context/StatisticContext";
import BackofficeContext from "../../../../context/BackofficeContext";
import "../../../../css/page/content/sale/Sale.css";
import "../../../../css/form/Form.css";
import "moment/locale/fr";
import LicenseController from "../../../../stories/_account/Licenses/LicenseController";
import StringTools from "../../../../class/tool/StringTools";
import SellerController from "../../../../stories/_setting/Sellers/SellerController";
import PricelistController from "../../../../stories/_catalog/Pricelists/PricelistController";
import SubCategoryController from "../../../../stories/_catalog/SubCategories/SubCategoryController";
import LoaderCircle from "../../../loader/LoaderCircle";
moment.locale("fr");

const Sale = props => {
    const item = "sales";
    const itemClass = "sale";
    const titleWindow = "Historique des ventes";
    const placeholderSearch = "une vente, un règlement, un produit ...";
    const titleNbItems = "ventes";
    const emptyList = "Aucune vente";
    const { setEvent } = useContext(BackofficeContext);
    const { dateBegin, dateEnd } = props;
    const [ loading, setLoading ] = useState({global: true, sales: false});
    const [ firstCall, setFirstCall ] = useState(true);
    const [ dashboard, setDashboard ] = useState(null);
    const [ exportForm, setExportForm ] = useState(false);
    const [ dateType, setDateType ] = useState("day");
    const [ dates, setDates ] = useState({ begin: moment().startOf("day").format(), end: moment().endOf("day").format() });
    const [ refreshStats, setRefreshStats ] = useState(false);
    const [ pageSelect, setPageSelect ] = useState(1);
    const [ list, setList ] = useState([]);
    const [ licenses, setLicenses ] = useState([]);
    const [ sellers, setSellers ] = useState([]);
    const [ pagination, setPagination ] = useState(null);
    const [ perPage, setPerPage ] = useState(25);
    const [ sortingName, setSortingName ] = useState("created_at");
    const [ sortingValue, setSortingValue ] = useState("desc");
    const [ filters, setFilters ] = useState({});
    const [ filterValues, setFilterValues ] = useState({});
    const [ contextValues, setContextValues ] = useState({});
    const [ showFilters, setShowFilters ] = useState(false);
    const prevPageSelect = usePrevious(pageSelect);
    const prevPerPage = usePrevious(perPage);
    const env = JSON.parse(localStorage.getItem("env"));

    const init = () => {
        initFilters();

        if (env.type === "store") {
            listLicenses();
            listSellers();
        }
        else {
            setLicenses([]);
            setSellers([]);
        }
    }
    const initDates = () => {
        const begin = (dateBegin !== undefined && dateBegin !== null) ? moment(dateBegin, "DD-MM-YYYY").format() : moment().startOf((dateType === "dual_day" ? "day" : dateType)).format();
        const end = (dateEnd !== undefined && dateEnd !== null) ? moment(dateEnd, "DD-MM-YYYY").format() : moment().endOf((dateType === "dual_day" ? "day" : dateType)).format();

        changeDates({
            begin,
            end
        });
    }
    const changeDates = dates => {
        changeDateSelected(dates);
    }
    const launchStats = () => {
        if (loading.global && !firstCall)
            return;

        setFirstCall(false);

        if (Object.keys(dates).length === 0)
            return;

        setRefreshStats(false);

        getDashboard();
    }
    const getDashboard = () => {
        setLoadingObj(null, true);

        const controller = new DashboardController();
        controller._callback = returnGetDashboard;
        controller.index({
            dateType: dateType,
            dates: dates,
            withVersus: false,
            withSubPeriods: false
        }, filterValues);
    }
    const returnGetDashboard = (object, error, status) => {
        switch (status) {
            case 200:
                setDashboard(object)
                break
            default: break
        }
    }
    const listLicenses = () => {
        let controller = new LicenseController();
        controller._callback = returnListLicenses;
        controller.index(env);
    }
    const returnListLicenses = (list, error, status) => {
        switch (status) {
            case 200:
                let datas = [
                    {
                        id: null,
                        name: "Toutes les caisses"
                    },
                    {
                        id: null,
                        name: "----------"
                    }
                ];

                for (let i in list) {
                    datas.push({
                        id: list[i].id,
                        name: StringTools.capitalizeFirstLetter(list[i].name.toLowerCase())
                    });
                }

                setLicenses(datas);
                break;
            default:
                console.error("Une erreur s'est produite lors de la récupération des licences. Code [G-LIC-" + status + "]");
                break;
        }
    }
    const listSellers = () => {
        let controller = new SellerController();
        controller._callback = returnListSellers;
        controller.index(null, null, null, "lastname", "asc", true);
    }
    const returnListSellers = (list, error, pagination, status) => {
        switch (status) {
            case 200:
                let datas = [
                    {
                        id: null,
                        name: "Tous les vendeurs"
                    },
                    {
                        id: null,
                        name: "----------"
                    }
                ];

                for (let i in list) {
                    datas.push({
                        id: list[i].id,
                        name: list[i].fullname
                    });
                }

                setSellers(datas);
                break;
            default:
                console.error("Une erreur s'est produite lors de la récupération des vendeurs. Code [G-SEL-" + status + "]");
                break;
        }
    }
    const callStats = () => {
        if (dashboard === null)
            return;

        setLoadingObj(["global", "sales"], true);

        const controller = new DashboardController();
        controller._callbackSales = returnGetSales;
        controller.get(dashboard, "sales", pageSelect, perPage, sortingName, sortingValue);
    }
    const returnGetSales = (list, error, pagination, status) => {
        setLoadingObj(["global", "sales"], false);

        switch (status) {
            case 200:
                setList(list);
                setPagination(pagination !== undefined ? pagination : null);
                break;
            case 500:
                setEvent({
                    type: "error",
                    text: "Une erreur s'est produite lors de la récupération des ventes"
                });
                console.error("returnGetSales", error);
                break;
            default:
                console.log("returnGetSales", error);
                break;
        }
    }
    const setLoadingObj = (keys = null, val) => {
        if (keys === null) {
            setLoading(prev => ({
                ...prev,
                global: val,
                sales: val
            }));
        }
        else {
            let loadingKeys = Object.keys(loading);

            for (let i in loadingKeys) {
                if (keys.includes(loadingKeys[i])) {
                    switch (loadingKeys[i]) {
                        case "global": setLoading(prev => ({...prev, global: val})); break;
                        case "sales": setLoading(prev => ({...prev, sales: val})); break;
                        default: break;
                    }
                }
            }
        }
    }
    const controlLoading = () => {
        let keys = Object.keys(loading);

        for (let i in keys) {
            if (keys[i] === "global") continue;

            if (loading[keys[i]])
                return;
        }

        if (loading.global && !firstCall)
            setLoadingObj(["global"], false);
    }
    const updatePageSelect = page => {
        setPageSelect(page)
    }
    const exportStats = () => {
        setExportForm(!exportForm);
    }
    const openFilters = () => {
        setShowFilters(true);
    }
    const closeFilters = () => {
        setShowFilters(false);
    }
    const validFilters = values => {
        closeFilters();
        setFilterValues(values);
    }
    const initFilters = () => {
        setFilterValues(prev => ({
            ...prev,
            license_id: null,
            seller_id: null,
            licenses: [],
            sellers: []
        }));
    }
    const updateFilters = () => {
        setFilters(prev => ({
            ...prev,
            licenses: licenses,
            sellers: sellers
        }));
    }
    const changeDateSelected = dates => {
        setDates({
            begin: dates.begin,
            end: dates.end
        });
    }

    const model = [
        {
            "class": "number",
            "sortingParam": "number",
            "title": "Numéro",
            "attributes": ["number"],
            "type": "text"
        },
        {
            "class": "seller",
            "sortingParam": "sellerName",
            "title": "Vendeur",
            "attributes": ["sellerName"],
            "type": "text"
        },
        {
            "class": "article",
            "sortingParam": "nbArticle",
            "title": "Articles",
            "attributes": ["nbArticle"],
            "type": "text"
        },
        {
            "class": "amount",
            "sortingParam": "amountInclTax",
            "title": "Montant",
            "attributes": ["amountInclTax"],
            "type": "price"
        },
        {
            "class": "created_at",
            "sortingParam": "created_at",
            "title": "Date",
            "attributes": ["created_at"],
            "type": "date"
        }
    ];
    const options = [];
    const secondaryOptions = [];

    useEffect(() => {
        document.title = "Back office - " + titleWindow;
        init();
    }, []);
    useEffect(() => {
        controlLoading();
    }, [loading]);
    useEffect(() => {
        setRefreshStats(true);
        initDates();
    }, [dateType]);
    useEffect(() => {
        if (prevPageSelect === undefined || prevPerPage === undefined) return;

        if (pageSelect !== prevPageSelect || perPage !== prevPerPage)
            callStats();
    }, [pageSelect, perPage]);
    useEffect(() => {
        callStats();
    }, [dashboard]);
    useEffect(() => {
        setRefreshStats(true);
    }, [filterValues]);
    useEffect(() => {
        if (Object.keys(dates).length > 0 && refreshStats)
            launchStats();
    }, [dates, refreshStats]);
    useEffect(() => {
        updateFilters();
    }, [licenses, sellers]);
    useEffect(() => {
        setContextValues(prev => ({
            ...prev,
            typeFilters: "statistics",
            filters,
            filterValues,
            showFilters,
            openFilters,
            closeFilters,
            validFilters
        }));
    }, [showFilters, filters, filterValues]);

    return(
        <StatisticContext.Provider value={{dateType, setDateType, dates, setDates: changeDates, loading}}>
            <ListingContext.Provider value={contextValues}>
                <FilterPopup />
                {
                    exportForm
                    && <ExportStats
                        type={"sale"}
                        cancel={exportStats}
                        dates={{
                            dates: dates,
                            compare: false,
                            withVersus: false,
                            withSubPeriods: false
                        }}
                        filters={filterValues}
                    />
                }
                <div className="main">
                    <ToolsBar loading={loading} launchStats={launchStats} launchExport={exportStats} dateTypesAvailable={['D']} noCompare={true} />
                </div>
                <Listing
                    item={ item }
                    itemClass={ itemClass }
                    placeholderSearch={ placeholderSearch }
                    titleNbItems={ titleNbItems }
                    emptyList={ emptyList }
                    model={ model }
                    options={ options }
                    secondaryOptions={ secondaryOptions }
                    activeHistory={ false }
                    pageSelect={ pageSelect }
                    updatePageSelect={ updatePageSelect }
                    list={ list }
                    loading={ false }
                    pagination={ pagination }
                    checkable={ false }
                    openable={ true }
                    setPerPage={ setPerPage }
                    sortingName={ sortingName }
                    sortingValue={ sortingValue }
                    setSortingName={ setSortingName }
                    setSortingValue={ setSortingValue }
                    noMarginTopWrapList={ true }
                />
                <Switch>
                    <Route exact path={ "/" + item + "/:id" }>
                        <PreviewBox previousLink={ item } type={"v2"} />
                    </Route>
                </Switch>
            </ListingContext.Provider>
        </StatisticContext.Provider>
    )
}

export default Sale;
